import { render, staticRenderFns } from "./LegalComponent.vue?vue&type=template&id=662c1e2c&scoped=true&"
import script from "./LegalComponent.vue?vue&type=script&lang=js&"
export * from "./LegalComponent.vue?vue&type=script&lang=js&"
import style0 from "./LegalComponent.vue?vue&type=style&index=0&id=662c1e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662c1e2c",
  null
  
)

export default component.exports